import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Label,
    Col,
    Row,
    ListGroupItem,
    ListGroup,
} from 'reactstrap';
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { convertCheckBoxValueToBoolean } from '../../../utils/CommonUtils';
import { saveCategory, deleteCategory, publishCategory, dispatchErrorMessage, loadRestaurantSettings } from '../../../actions';
import BatchUpdateConfirmationScreen from './common/batchUpdate/BatchUpdateConfirmationScreen';
import ConfirmationScreen from '../settings/pos/ConfirmationScreen';
import MenuPartsFooter from './common/MenuPartsFooter';
import PopoverCommon from './common/PopoverCommon';
import AvailabilitySettings from './common/availability/AvailabilitySettings';
import MainInformation from './common/MainInformation';
import CategoryImage from './common/additionalInformation/CategoryImage';
// import { getCroppedImg, createFileFromBase64ImageData } from '../../../utils/CropImageUtils';
// import CropImageModal from '../../common/CropImageModal';

class CategoryScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentCategory: {
                id: -1,
                name: "",
                description: "",
                minimumQuantity: null,
                active: false,
                menuDraftId: -1,
                availableTimes: [],
                categoryAvailableAllDay: true,
                imageUrl: null,
                origin: '',
                canBeDeleted: false,
                canBePublished: false,
                published: false,
                multipleActivateOrDeactivate: false,
                multipleNameChange: false,
                multipleDescriptionChange: false
            },
            additionalInfo: true,
            modalSize: true,
            additionalArrowIcon: false,
            imageArrowIcon: true,
            stateAlreadyCopiedFromProps: false,
            originPopoverOpen: false,
            activePopoverOpen: false,
            tooltipOpen: false,
            publishTooltipOpen: false,
            isBatchDeactivateBtnPressed: false,
            isDeleteBtnPressed: false,
            imagePreview: null,
            imageFormData: null,
            // cropCategoryImageModalOpened: false,
            categoryImageBase64: null,
            imageExtension: null,
            showDeleteImageTooltip: false,
            uploadImage: false,
            imageFieldValue: ''
        }

        this.toggle = this.toggle.bind(this);
        this.changeState = this.changeState.bind(this);
        this.deleteCategory = this.deleteCategory.bind(this);
        this.toggleOriginPopover = this.toggleOriginPopover.bind(this);
        this.toggleActivePopover = this.toggleActivePopover.bind(this);
        this.toggleTooltip = this.toggleTooltip.bind(this);
        this.togglePublishTooltip = this.togglePublishTooltip.bind(this);
        this.publishCategory = this.publishCategory.bind(this);
        this.saveCategory = this.saveCategory.bind(this);
        this.saveCurrentCategory = this.saveCurrentCategory.bind(this);
        this.changeConfirmationType = this.changeConfirmationType.bind(this);
        this.toggleBatchDeactivateConfirmation = this.toggleBatchDeactivateConfirmation.bind(this);
        this.changeCategoryOperationHours = this.changeCategoryOperationHours.bind(this);
        // Availability binds
        this.updatePrepTimesState = this.updatePrepTimesState.bind(this);
    }

    componentWillUnmount() {
        this.resetModalState();
    }

    componentDidMount() {
        const restaurantId = this.props.restaurantId;
        this.props.loadRestaurantSettings(restaurantId);

        if (this.props.category.id) {
            this.copyStateFromProps();
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.serviceSettingsGeneral !== this.props.serviceSettingsGeneral) {
            if (this.props.serviceSettingsGeneral.enableLargeImageDesign) {
                this.setState({
                    uploadImage: !this.state.uploadImage,
                    modalSize: !this.state.modalSize,
                    imageArrowIcon: !this.state.imageArrowIcon
                })
            }
        }
    }

    copyStateFromProps() {
        this.setState(
            {
                currentCategory: {
                    id: this.props.category.id ? this.props.category.id : -1,
                    name: this.props.category.name,
                    description: this.props.category.description ? this.props.category.description : '',
                    minimumQuantity: this.props.category.minimumQuantity,
                    active: this.props.category.active,
                    origin: this.props.category.origin,
                    canBeDeleted: this.props.category.canBeDeleted,
                    canBePublished: this.props.category.canBePublished,
                    published: this.props.category.published,
                    menuDraftId: this.props.menuDraftId,
                    currentМenuDraftId: this.props.menuDraftId,
                    availableTimes: this.props.category.availableTimes,
                    categoryAvailableAllDay: this.props.category.categoryAvailableAllDay,
                    multipleActivateOrDeactivate: false,
                    multipleNameChange: false,
                    multipleDescriptionChange: false,
                    categoryId: this.props.category.categoryId,
                    imageUrl: this.props.category.imageUrl ? this.props.category.imageUrl : ''
                    // currentМenuDraftId is used for reloading answers in its group.
                    // In the flow menuDraftId can be changed, that's why we
                    // are using questionId in loadCategories action.
                },
                invalidSubmit: false,
                stateAlreadyCopiedFromProps: true
            }
        )
    }

    resetModalState() {
        this.state.currentCategory.id = -1;
        this.state.currentCategory.name = "";
        this.state.currentCategory.description = "";
        this.state.currentCategory.minimumQuantity = null;
        this.state.currentCategory.active = false;
        this.state.currentCategory.origin = "";
        this.state.currentCategory.canBeDeleted = false;
        this.state.currentCategory.canBePublished = false;
        this.state.currentCategory.published = false;
        this.state.currentCategory.menuDraftId = -1;
        this.state.currentCategory.openingHours = [];
        this.state.currentCategory.categoryAvailableAllDay = true;
        this.state.originPopoverOpen = false;
        this.state.activePopoverOpen = false;
        this.state.tooltipOpen = false;
        this.state.publishTooltipOpen = false;
        this.state.showErrorMsg = false;
        this.state.additionalInfo = true;
        this.state.modalSize = true;
        this.state.additionalArrowIcon = false;
        this.state.imageArrowIcon = false;
        this.state.invalidSubmit = false;
        this.state.stateAlreadyCopiedFromProps = false;
        this.state.isBatchDeactivateBtnPressed = false;
        this.state.isDeleteBtnPressed = false;
        this.state.showDeleteImageTooltip = false;
        this.state.imagePreview = null;
        this.state.imageFormData = null;
        this.state.uploadImage = true;
    }

    toggleDeleteConfirmationWindow() {
        this.setState({
            ...this.state,
            isDeleteBtnPressed: !this.state.isDeleteBtnPressed
        });
    }

    toggleBatchDeactivateConfirmation() {
        this.setState({
            ...this.state,
            isBatchDeactivateBtnPressed: !this.state.isBatchDeactivateBtnPressed
        });
    }

    toggleAdditionalInformation() {

        if (!this.state.uploadImage) {
            this.setState({
                ...this.state,
                uploadImage: !this.state.uploadImage,
                imageArrowIcon: !this.state.imageArrowIcon,
                additionalInfo: !this.state.additionalInfo,
                additionalArrowIcon: !this.state.additionalArrowIcon,
            })
        } else {
            this.setState({
                ...this.state,
                additionalInfo: !this.state.additionalInfo,
                modalSize: !this.state.modalSize,
                additionalArrowIcon: !this.state.additionalArrowIcon,
            })
        }
    }

    toggleUploadImage() {

        if (!this.state.additionalInfo) {
            this.setState({
                ...this.state,
                additionalInfo: !this.state.additionalInfo,
                additionalArrowIcon: !this.state.additionalArrowIcon,
                uploadImage: !this.state.uploadImage,
                imageArrowIcon: !this.state.imageArrowIcon,
            })
        } else {
            this.setState({
                ...this.state,
                uploadImage: !this.state.uploadImage,
                modalSize: !this.state.modalSize,
                imageArrowIcon: !this.state.imageArrowIcon,
            })
        }
    }



    toggle(saveOrPublish) {
        this.resetModalState();
        this.props.onToggle(this.state.currentCategory, saveOrPublish, "category");
    }

    toggleOriginPopover() {
        this.setState({
            originPopoverOpen: !this.state.originPopoverOpen
        });
    }

    toggleTooltip() {
        this.setState({
            modifyPriceTooltip: !this.state.tooltipOpen
        });
    }

    togglePublishTooltip() {
        this.setState({
            publishTooltipOpen: !this.state.publishTooltipOpen
        });
    }

    changeState({ target }) {
        if (target.name !== 'minimumQuantity' && target.name !== 'description' && target.value !== '' && (target.value == true || target.value == 'true' || target.value == false || target.value == 'false')) {
            this.setState({
                currentCategory: {
                    ...this.state.currentCategory,
                    [target.name]: convertCheckBoxValueToBoolean({ target })
                }
            });
        } else {
            this.setState({
                currentCategory: {
                    ...this.state.currentCategory,
                    [target.name]: target.value
                }
            });
        }
    }

    changeConfirmationType({ target }) {

        this.setState({
            ...this.state,
            currentProduct: {
                ...this.state.currentProduct,
                [target.name]: target.value === 'true' ? true : false
            }
        });
    }

    saveCategory(publishCategoryCallback) {
        if (this.state.currentCategory.id == -1 && this.props.menuDraftId !== undefined && this.props.menuDraftId !== -1) {

            this.state.currentCategory.menuDraftId = this.props.menuDraftId;
        }

        if (!this.state.currentCategory.id == -1 || !(this.state.currentCategory.active == this.props.category.active &&
            this.state.currentCategory.name === this.props.category.name && this.state.currentCategory.description === this.props.category.description)) {

            this.saveCurrentCategory(publishCategoryCallback);
            return;
        }


        this.saveCurrentCategory(publishCategoryCallback);

        // TODO check this strange code 
        // if (!this.state.isDescriptionChanged && !this.state.isNameChanged && !this.state.isActiveChanged) {
        //     this.saveCurrentCategory(publishCategoryCallback);
        // }

    }

    saveCurrentCategory(publishCategoryCallback) {
        const saveCategoryCallbackOnSuccess = () => {
            if (!publishCategoryCallback) {
                this.toggle(true);
            }
        };

        const restaurantId = this.props.restaurantId;
        const invalidSubmit = this.state.invalidSubmit;
        this.props.saveCategory(this.state.currentCategory, restaurantId, this.state.imageFormData, invalidSubmit, publishCategoryCallback, saveCategoryCallbackOnSuccess, undefined);
    }

    deleteCategory() {
        this.props.deleteCategory(this.state.currentCategory);
        this.toggle();
    }

    publishCategory() {

        const publishCategoryCallback = () => {
            this.props.publishCategory(this.state.currentCategory, this.props.menuDraftId);
            this.toggle(true);
        };

        this.saveCategory(publishCategoryCallback);
    }

    renderOriginPopover() {
        const originMsg =
            (this.state.currentCategory.origin !== undefined && this.state.currentCategory.origin !== null
                && this.state.currentCategory.origin !== '') ? this.state.currentCategory.origin : i18n.t('common:popovers.origin');

        return (
            <PopoverCommon
                isOpen={this.state.originPopoverOpen}
                target="origin"
                toggle={this.toggleOriginPopover}
                textContent={originMsg}
            />
        );
    }

    toggleActivePopover() {
        this.setState({
            activePopoverOpen: !this.state.activePopoverOpen
        });
    }

    renderActivePopover() {
        return (
            <PopoverCommon
                isOpen={this.state.activePopoverOpen}
                target="active"
                toggle={this.toggleActivePopover}
                textContent={i18n.t('screens:categoryScreen.activePopover')}
            />
        );
    }

    renderCategoriesForm() {

        return (
            <AvForm id={-1} className="modalForm" onValidSubmit={() => { this.saveCategory() }}>
                <ModalHeader className="modalHeader" toggle={this.toggle}>{i18n.t('screens:categoryScreen.heading')}</ModalHeader>
                <ModalBody>
                    {this.renderModalBody()}
                </ModalBody>
                {this.renderCategoryInfoFooter()}
            </AvForm>
        );
    }

    renderModalBody() {
        const { activeGroupStyle, listGroupItem,
            alignRight, activeLabel, marginLeft, cursorPointer } = styles;

        let colSize = 12;
        let additionalArrowIcon = 'keyboard_arrow_right';
        let imageArrowIcon = 'keyboard_arrow_right';
        let additionalActiveInfo = '';
        let imageActiveInfo = '';
        let additionalIconColor = '#000';
        let imageIconColor = '#000';

        if (this.state.additionalArrowIcon) {
            colSize = 6;
            additionalArrowIcon = 'keyboard_arrow_left';
            additionalActiveInfo = 'active';
            additionalIconColor = '#0288D1';
        } else if (this.state.imageArrowIcon) {
            colSize = 6;
            imageArrowIcon = 'keyboard_arrow_left';
            imageActiveInfo = 'active';
            imageIconColor = '#0288D1';
        } else {
            colSize = 12;
            additionalArrowIcon = 'keyboard_arrow_right';
            imageArrowIcon = 'keyboard_arrow_right';
        }

        const isHidden = this.state.currentCategory.id === -1 ? true : false;

        return (
            <Row>
                <Col xs="12" sm={this.state.modalSize ? 5 : colSize}>
                    <MainInformation
                        styles={styles}
                        nameValue={this.state.currentCategory.name}
                        onChange={this.changeState}
                        descriptionValue={this.state.currentCategory.description}
                        draftName={'menuDraftId'}
                        labelText={i18n.t('screens:categoryScreen.reassign')}
                        options={this.props.menus}
                        isDraftHidden={isHidden}
                        selectValue={this.state.currentCategory.menuDraftId}
                    />
                    <AvGroup style={activeGroupStyle} id="activeCheckboxGroup">
                        <span onClick={this.toggleActivePopover} id="active" style={cursorPointer} >
                            <MaterialIcon icon="help" color="#ff990a" size={20} />
                        </span>
                        {this.renderActivePopover()}
                        <Label style={activeLabel} for="active">{i18n.t('common:buttons.active')}</Label>
                        <AvInput
                            name="active" type="checkbox"
                            checked={!!this.state.currentCategory.active}
                            onChange={this.changeState}
                            style={marginLeft} />
                    </AvGroup>
                    {
                        !this.props.serviceSettingsGeneral.enableLargeImageDesign ?
                            <ListGroup onClick={this.toggleUploadImage.bind(this)} flush>
                                <ListGroupItem style={listGroupItem} className={imageActiveInfo}>
                                    {i18n.t('screens:categoryScreen.uploadCategoryImage')}
                                    <span style={alignRight}><MaterialIcon icon={imageArrowIcon} color={imageIconColor} size={20} /></span>
                                </ListGroupItem>
                            </ListGroup> : null
                    }
                    <ListGroup onClick={this.toggleAdditionalInformation.bind(this)} flush>
                        <ListGroupItem style={listGroupItem} className={additionalActiveInfo}>
                            {i18n.t('screens:menuConfigScreen.availabilityHours')}
                            <span style={alignRight}><MaterialIcon icon={additionalArrowIcon} color={additionalIconColor} size={20} /></span>
                        </ListGroupItem>
                    </ListGroup>
                </Col>
                {
                    !this.props.serviceSettingsGeneral.enableLargeImageDesign ?
                    <Col xs="12" sm={this.state.modalSize ? 7 : 6} hidden={this.state.uploadImage}>
                        {this.renderCategoryImage()}
                    </Col> : null
                }
                <Col xs="12" sm={this.state.modalSize ? 7 : 6} hidden={this.state.additionalInfo}>
                    {this.renderAvailabilitySettings()}
                </Col>
            </Row>
        );
    }

    renderAvailabilitySettings() {

        return (
            <AvailabilitySettings
                screen={'category'}
                preparationTimes={this.state.currentCategory.availableTimes}
                showErrorMsg={this.state.showErrorMsg}
                state={this.state}
                // Hardcoded value that diferentiates the two different types of the sub component's rendering
                availabilitySettings={true}
                itemAvailableAllDay={this.state.currentCategory.categoryAvailableAllDay}
                updatePrepTimes={this.updatePrepTimesState}
                changeMenuOperationHours={this.changeCategoryOperationHours}
            />
        );
    }

    renderCategoryImage() {

        const deleteImageButtonElement = document.getElementById('deleteCategoryImageButton');
        let includeTooltip = false;
        (deleteImageButtonElement) ? includeTooltip = true : includeTooltip = false;

        return (
            <CategoryImage
                imagePreview={this.state.imagePreview}
                currentCategory={this.state.currentCategory}
                uploadImage={this.uploadImage.bind(this)}
                deleteCategoryImage={this.deleteCategoryImage.bind(this)}
                includeTooltip={includeTooltip}
                showDeleteImageTooltip={this.state.showDeleteImageTooltip}
                toggleDeleteImageTooltip={this.toggleDeleteImageTooltip.bind(this)}
                imageFieldValue={this.state.imageFieldValue}
            />
        )
    }

    uploadImage(event) {
        event.preventDefault();
        const file = event.target.files[0];

        if (file.size > 1000000) {
            this.props.dispatchErrorMessage(`${i18n.t('common:validations.maximumImageSize')} 1MB`)
        } else {
            if (file !== undefined) {                           // file === undefined when you click cancel
                this.setState({
                    ...this.state.currentCategory,
                    imagePreview: URL.createObjectURL(file),
                    imageFormData: event.target.files[0],
                    imageFieldValue: event.target.value

                });

                //this is for crop image
                // let reader = new FileReader();

                // reader.onloadend = () => {
                //     this.setState({
                //         ...this.state,
                //         categoryImageBase64: reader.result,
                //         imageExtension: file.type
                //     }, () => this.toggleCategoryImageCropModal());
                // };
                // reader.readAsDataURL(file);
            }
        }
    }

    // toggleCategoryImageCropModal = () => {
    //     this.setState({
    //         ...this.state,
    //         cropCategoryImageModalOpened: !this.state.cropCategoryImageModalOpened
    //     });
    // }

    // onCropCategoryImageUpload = async (crop) => {
    //     try {
    //         const imageData = await getCroppedImg(crop.image, crop.croppedAreaPixels, 0, this.state.imageExtension);
    //         const blobData = createFileFromBase64ImageData(imageData, this.state.imageExtension);
    //         const uploadImageExtension = this.state.imageExtension.split('/')[1];
    //         const imageFile = new File([blobData], `categoryImage.${uploadImageExtension}`, { type: blobData.type });

    //         this.setState({
    //             ...this.state.currentCategory,
    //             imagePreview: imageData,
    //             imageFormData: imageFile
    //         }, () => this.toggleCategoryImageCropModal());
    //     } catch (e) {
    //         console.error(e);
    //     }
    // }

    toggleDeleteImageTooltip() {
        this.setState({ ...this.state, showDeleteImageTooltip: !this.state.showDeleteImageTooltip });
    }

    deleteCategoryImage() {
        const restaurantId = this.props.restaurantId;

        const deleteImageArgument = () => {
            let copyOfCategory = _.cloneDeep(this.state.currentCategory);
            copyOfCategory.imageUrl = null;

            this.setState({ ...this.state, currentCategory: copyOfCategory, imagePreview: null, imageFieldValue: '', imageFormData: null });
        };

        this.props.saveCategory(this.state.currentCategory, restaurantId, undefined, undefined, undefined, undefined, deleteImageArgument);
    }

    updatePrepTimesState(prepTimes, showErrorMsg) {
        this.setState({
            ...this.state,
            currentCategory: {
                ...this.state.currentCategory,
                availableTimes: prepTimes
            },
            showErrorMsg: true
        });
    }

    changeCategoryOperationHours({ target }) {

        this.setState({
            currentCategory: {
                ...this.state.currentCategory,
                categoryAvailableAllDay: target.value === 'always' ? true : false
            }
        });
    }

    renderCategoryInfoFooter() {
        const publishTooltipMsg =
            (this.state.currentCategory.id === undefined || this.state.currentCategory.id === -1)
                ? i18n.t('common:popovers.newItemMsg') : i18n.t('screens:categoryScreen.publishTooltip');

        const deleteTooltipMsg =
            (this.state.currentCategory.id === undefined || this.state.currentCategory.id === -1)
                ? i18n.t('common:popovers.newItemMsg') : i18n.t('common:popovers.deleteMsg');

        return (
            <Fragment>
                <MenuPartsFooter
                    styles={styles}
                    state={this.state}
                    isPublishDisabled={!this.state.currentCategory.canBePublished ? true : false}
                    publishTooltipMsg={publishTooltipMsg}
                    onClickPublish={this.publishCategory}
                    publishTooltipToggle={this.togglePublishTooltip}
                    isDeleteDisabled={!this.state.currentCategory.canBeDeleted ? true : false}
                    deleteTooltipMsg={deleteTooltipMsg}
                    onClickDelete={this.toggleDeleteConfirmationWindow.bind(this)}
                    deleteTooltipToggle={this.toggleTooltip}
                    onClickOrigin={this.toggleOriginPopover}
                    publishedItemId={this.state.currentCategory.categoryId}
                />
                {this.renderOriginPopover()}
            </Fragment>
        );
    }

    batchUpdateConfirmationScreen() {

        return (
            <BatchUpdateConfirmationScreen
                screen={'category'}
                isActive={this.state.currentCategory.active}
                isOpen={this.state.isBatchDeactivateBtnPressed}
                onToggle={this.toggle}
                onSave={this.saveCurrentCategory}
                onChange={this.changeConfirmationType}
                statusChanged={this.state.currentCategory.active !== this.props.category.active}
                nameChanged={this.state.currentCategory.name !== this.props.category.name}
                descriptionChanged={this.state.currentCategory.description !== this.props.category.description}
            />
        );
    }

    renderConfirmationScreen() {
        let textData = {
            firstRow: i18n.t('screens:categoryScreen.deleteMenuConfirmationText'),
            header: i18n.t('screens:categoryScreen.deleteMenuHeader')
        };

        return (
            <ConfirmationScreen
                isOpen={this.state.isDeleteBtnPressed}
                onToggle={this.toggle}
                onSave={this.deleteCategory}
                hasDeleteBtn={true}
                message={textData}
            />
        );
    }

    render() {
        let modalSize = '';
        if (this.state.modalSize === true && !this.state.saveUnactiveCategoryPressed && !this.state.saveActiveCategoryPressed) {
            modalSize = 'lg'
        } else {
            modalSize = 'md'
        }

        return (
            <div>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle} size={modalSize} className='categoryScreen'>
                    {(!this.state.isDeleteBtnPressed) ?
                        (this.state.isBatchDeactivateBtnPressed) ? this.batchUpdateConfirmationScreen() : this.renderCategoriesForm()
                        : this.renderConfirmationScreen()}
                </Modal>
                {/* {
                    this.state.cropCategoryImageModalOpened ?
                        <CropImageModal
                            isOpen={this.state.cropCategoryImageModalOpened}
                            onClickSave={this.onCropCategoryImageUpload}
                            toggle={this.toggleCategoryImageCropModal}
                            modalClass='cropCategoryImage'
                            crop={{
                                image: this.state.categoryImageBase64,
                                crop: { x: 0, y: 0 },
                                zoom: 1,
                                cropSize: { width: 1035, height: 350 },
                                croppedAreaPixels: null,
                            }}
                        /> : null
                } */}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        menus: state.menus,
        serviceSettingsGeneral: state.serviceSettingsGeneral
    };
};

export default connect(mapStateToProps, { saveCategory, deleteCategory, publishCategory, dispatchErrorMessage, loadRestaurantSettings })(CategoryScreen);

let styles = {
    categoryAvailabilityRadioBtns: {
        marginLeft: 10,
        marginRight: 10
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: -5,
        paddingLeft: 0
    },
    alignRight: {
        marginLeft: 'auto'
    },
    activeGroupStyle: {
        paddingLeft: '0.4rem',
        width: '100%'
    },
    descriptionStyle: {
        height: 130
    },
    listGroupItem: {
        display: 'flex',
        background: 'none',
        borderBottom: '1px solid #dee2e7',
        cursor: 'pointer',
        borderTop: 'none',
        paddingLeft: '0.2rem',
        paddingRight: 0,
        paddingTop: 0
    },
    originStyle: {
        color: '#0288d1',
        marginRight: 'auto',
        padding: 0,
    },
    activeLabel: {
        marginLeft: 6
    },
    popoverStyle: {
        padding: '12px 6px 0px 6px'
    },
    marginLeft: {
        marginLeft: 10
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    spaceBetween: {
        paddingLeft: 4
    },
    inputCounter: {
        textAlign: 'right',
        fontSize: 12,
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/CategoryScreen.js